import { useState } from "react";
import { useForm } from "react-hook-form";
import api from "service/api";
import { toast } from "react-toastify";
import { Button, FormGroup, Modal, Row, Col, CardHeader } from "reactstrap";

const ModalEditIpGroups = (props) => {
  const { id, ipAddresses, name, update, setUpdate } = props;
  const [defaultModal, setDefaultModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [formModal, setFormModal] = useState(false);
  const { register, handleSubmit } = useForm();
  const ipRegex =
    /^((\*|(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?)(,(\*|(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?))*)$/;

  const toggleModal = (state) => {
    switch (state) {
      case "defaultModal":
        setDefaultModal(!defaultModal);
        break;
      case "notificationModal":
        setNotificationModal(!notificationModal);
        break;
      case "formModal":
        setFormModal(!formModal);
        break;
      default:
        break;
    }
  };

  const onSubmit = (data) => {
    if (!data.name.trim()) {
      toast.error("Preencha o campo nome corretamente!");
      return;
    }

    if (!ipRegex.test(data.ipAddresses)) {
      toast.error("Formato de IP inválido!");
      return;
    }

    api
      .put(`/ip-groups/${id}`, data)
      .then(() => {
        toast.success("Grupo de ips editado com sucesso!");
        toggleModal("defaultModal");
        setUpdate(!update);
      })
      .catch(() => {
        toast.error("Erro ao editar grupo de ips!");
      });
  };

  return (
    <>
      <Row>
        <Col md="4">
          <Button
            block
            color="primary"
            type="button"
            style={{ width: "auto" }}
            onClick={() => toggleModal("defaultModal")}
          >
            Editar
          </Button>
          <Modal
            className="modal-dialog-centered"
            isOpen={defaultModal}
            toggle={() => toggleModal("defaultModal")}
          >
            <div className="modal-header">
              <button
                aria-label="Close"
                className="close pb-0"
                data-dismiss="modal"
                type="button"
                onClick={() => toggleModal("defaultModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <CardHeader className="border-0 pb-0">
              {" "}
              Editar Grupo de Ips{" "}
            </CardHeader>
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pl-lg-4">
                  <Row>
                    <Col md="12" lg="8">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-topic"
                        >
                          Nome
                        </label>
                        <input
                          className="form-control-alternative custom-input "
                          defaultValue={name}
                          id="name"
                          placeholder="Nome"
                          type="text"
                          {...register("name")}
                          autoComplete="off"
                        />
                      </FormGroup>
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-topic"
                        >
                          Ips
                        </label>
                        <input
                          name="ipAddresses"
                          id="ipAddresses"
                          className="Input custom-input"
                          autoComplete="off"
                          defaultValue={ipAddresses}
                          required
                          {...register("ipAddresses")}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <Button type="submit">Atualizar</Button>
              </form>
            </div>
          </Modal>
        </Col>
      </Row>
    </>
  );
};

export default ModalEditIpGroups;
